import SignupForm from "./SignupForm";

export default function SignUp() {
  return <SignupForm role="teacher" />;
}
